import { StylesConfig } from 'react-select';

export const filterSelectStyles: StylesConfig = {
    control: (base, props) => ({
        ...base,
        border: 'none',
        backgroundColor: '#f1f2f4',
        fontSize: '0.75rem',
        boxShadow: props.isFocused ? '1px 1px 1px #90a0b7' : 'none',
    }),
    valueContainer: (base) => ({
        ...base,
        padding: '0.25rem 0.625rem',
        height: '1.75rem',
    }),
    clearIndicator: (base) => ({
        ...base,
        padding: 'none',
    }),
};
